import React from "react";
import { Card, CardContent, Grid, Box, Typography, CardMedia } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import ProductScape from "../../assets/ProductPos.png"
import Chip from '@mui/material/Chip';

const ideas = [
  {
    title: "Cartoon",
    description: "Turn your photo into a fun cartoon delight!",
    images: ['https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/genrated_images/677cfc53731e9e2f60a9113b/68146db837ac9f090a4ca50a/5NjjRRJHvcjJRKnWjIKak_b873bf0ec7334ac493e287a3da6c0481.png'],
    type: "cartoon",
  },
   {
      title: 'Productscape',
      description: "Make your product shine in real-world style visuals.",
      images: [ProductScape],
      type: "Productscape",
      chip: "New",
    },

 

];


const ValentineIdeaCards = () => {
  const navigate = useNavigate();
  return (
    <Grid item xs={12} className="gradient-background height-content">
      <Grid container spacing={2} className="idea-board-model">
        {ideas.map((idea, index) => (
          <Grid
            item
            xs={12}
            sm={12 / 2}
            md={12 / 4}
            lg={12 / 4}
            key={idea.title}
            style={{ cursor: "pointer", padding: "20px 30px" }}
          >
            <Card
              className="idea-card"
              onClick={() => navigate(`/idea-board/${idea.type}`)}
            >
              {idea.chip && (
                <Box sx={{ position: 'absolute', top: 12, left: 0, zIndex: 2 }}>
                  <Chip label={idea.chip} className="chipstyle" />
                </Box>
              )}
              {idea.images.slice(0, 2).map((img, i) => (
                <CardMedia
                  key={i}
                  component="img"
                  className="modalCardMedia"
                  image={img}
                  alt={`Image ${i + 1}`}
                />
              ))}
            </Card>
            <CardContent className="card-content" onClick={() => navigate(`/idea-board/${idea.type}`)}>
              <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} mb={1} className="card-title showcaseSubTitle">
                <Typography variant="h6" className="card-title showcaseSubTitle">{idea.title}</Typography>
                <div
                  onClick={() => navigate(`/idea-board/${idea.type}`)}
                  className="arrow-icon"
                >
                  <ArrowForwardIcon />
                </div>
              </Box>
              <Typography className="card-description showcaseSubDescription">{idea.description}</Typography>

            </CardContent>
          </Grid>
        ))}
      </Grid>


    </Grid>
  );
};

export default ValentineIdeaCards;
